var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2864 3.90818C11.0637 2.61654 12.9363 2.61654 13.7136 3.90818L15.6008 7.04403L19.1663 7.86981C20.6349 8.20995 21.2136 9.99089 20.2254 11.1293L17.8262 13.8931L18.1426 17.5394C18.273 19.0412 16.758 20.1419 15.3699 19.5538L12 18.1261L8.63002 19.5538C7.24195 20.1419 5.72699 19.0412 5.85733 17.5394L6.17377 13.8931L3.77458 11.1293C2.78636 9.99089 3.36503 8.20995 4.83365 7.86981L8.39919 7.04403L10.2864 3.90818ZM12 4.93945L10.1128 8.0753C9.83355 8.53932 9.37805 8.87026 8.85045 8.99245L5.28491 9.81824L7.68411 12.5821C8.03913 12.9911 8.21311 13.5265 8.16628 14.0661L7.84984 17.7123L11.2198 16.2846C11.7185 16.0733 12.2815 16.0733 12.7802 16.2846L16.1501 17.7123L15.8337 14.0661C15.7869 13.5265 15.9608 12.9911 16.3159 12.5821L18.7151 9.81824L15.1495 8.99245C14.6219 8.87026 14.1664 8.53932 13.8872 8.0753L12 4.93945Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/Star.aad3476a.svg";
export { ForwardRef as ReactComponent };